<div class="progress-container" [style]="containerStyles()">
  <div class="progress-bar" [style]="progressStyles()" [class.shimmer]="showShimmer()"></div>
</div>
